import axios from 'axios'

const state = {
  data: null
}

const actions = {
  async load ({ commit }) {
    try {
      const { data } = await axios.get('/pages')
      commit('set', data.data)
      return data.data
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

const mutations = {
  set (state, data) {
    state.data = data
  }
}

export default {
  state,
  actions,
  mutations,
  namespaced: true
}
